import api from './api';

export interface BrandingConfig {
  brandName: string;
  primaryColor: string;
  logoUrl: string;
}

const FRONTEND_BRANDING_FALLBACK: BrandingConfig = {
  brandName: 'Azzura Group',
  primaryColor: '#006EA6',
  logoUrl: '/azzura-mark.png'
};

const HEX_COLOR_PATTERN = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
const LEGACY_AZZURA_ORANGE_PRIMARY_COLOR = '#fa8c16';

export const normalizeBrandPrimaryColor = (value: string | undefined): string => {
  if (!HEX_COLOR_PATTERN.test(value || '')) {
    return FRONTEND_BRANDING_FALLBACK.primaryColor;
  }

  if (value?.toLowerCase() === LEGACY_AZZURA_ORANGE_PRIMARY_COLOR) {
    return FRONTEND_BRANDING_FALLBACK.primaryColor;
  }

  if (value && value.length === 4) {
    return `#${value[1]}${value[1]}${value[2]}${value[2]}${value[3]}${value[3]}`;
  }

  return value as string;
};

export const normalizeBranding = (data: Partial<BrandingConfig>): BrandingConfig => ({
  brandName: data.brandName || FRONTEND_BRANDING_FALLBACK.brandName,
  primaryColor: normalizeBrandPrimaryColor(data.primaryColor),
  logoUrl: typeof data.logoUrl === 'string' ? data.logoUrl : FRONTEND_BRANDING_FALLBACK.logoUrl
});

export const brandingApi = {
  async getBranding(): Promise<BrandingConfig> {
    const response = await api.get<BrandingConfig>('/branding');
    return normalizeBranding(response.data);
  }
};

export const getFallbackBranding = (): BrandingConfig => FRONTEND_BRANDING_FALLBACK;
